export default __webpack_public_path__ + "static/media/chipCard.20e6014a.png";